import merchant from './merchant'

export default merchant
